<template>
  <a-layout>
      <global-header
        :menuData="menuData"
        :collapsed="collapsed"
        :roles="roles"
        :currentRoleId="currentRoleId"
        @toggleCollapse="toggleCollapse"
        @roleSwitch="handleRoleSwitch"/>
      <a-layout>
        <sider-menu
          :theme="theme"
          :menuData="menuData"
          :collapsed="collapsed"
          :collapsible="true"/>
        <a-layout-content :style="contentStyle">
          <a-spin v-if="!menuLoaded" class="global-layout-loading" size="large" />
          <slot v-else></slot>
        </a-layout-content>
      </a-layout>
      <a-layout-footer style="padding: 0px">
        <global-footer :link-list="linkList" :copyright="copyright"/>
      </a-layout-footer>
  </a-layout>
</template>
<script>
import SiderMenu from '../components/menu/SiderMenu'
import GlobalHeader from './GlobalHeader'
import GlobalFooter from './GlobalFooter'
export default {
  name: 'GlobalLayout',
  components: {
    SiderMenu,
    GlobalHeader,
    GlobalFooter
  },
  data () {
    return {
      collapsed: false,
      menuData: [],
      menuLoaded: false,
      roles: [],
      currentRoleId: '',
      showSetting: false
    }
  },
  computed: {
    theme () {
      return this.$store.state.setting.theme
    },
    layout () {
      return this.$store.state.setting.layout
    },
    linkList () {
      return this.$store.state.setting.footerLinks
    },
    copyright () {
      return this.$store.state.setting.copyright
    },
    contentStyle () {
      const fixedHeader = this.$store.state.setting.fixedHeader
      let style = {
        margin: '0 0 0 256px',
        padding: '0 0 72px 0',
        minHeight: window.innerHeight - 122 + 'px'
      }
      if (fixedHeader) {
        style.paddingTop = '70px'
      }
      return style
    }
  },
  created () {
    this.$axios.post('/api/auth/getRoles.do', { op: '' }).then(res => {
      const detail = res.data.detail || {}
      this.roles = detail.roles || []
      this.currentRoleId = detail.currentRoleId || ''
      if (!this.currentRoleId && this.roles.length > 0) {
        this.currentRoleId = this.roles[0].id
      }
      this.applyMenuByRoleId(this.currentRoleId)
    })
  },
  methods: {
    applyMenuByRoleId (roleId) {
      const role = this.roles.find(r => r.id === roleId)
      if (role && role.menus) {
        this.menuData = role.menus.children || []
      } else {
        this.menuData = []
      }
      this.menuLoaded = true
    },
    handleRoleSwitch (roleId) {
      if (roleId === this.currentRoleId) return
      this.$axios.post('/api/auth/switchRole.do', { roleId }).then(() => {
        this.currentRoleId = roleId
        this.applyMenuByRoleId(roleId)
        const firstMenu = this.getFirstRoutePath(this.menuData)
        if (firstMenu && this.$route.path !== firstMenu) {
          this.$router.push(firstMenu)
        }
      }).catch(() => {
        this.$message.error('角色切换失败')
      })
    },
    getFirstRoutePath (menus) {
      if (!menus || menus.length === 0) return ''
      const first = menus[0]
      if (first.children && first.children.length > 0) {
        return this.getFirstRoutePath(first.children)
      }
      return first.path || ''
    },
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>
<style lang="less" scoped>
.global-layout-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  width: 100%;
}
</style>
